import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero/Hero';
import Ticker from '../components/Ticker/Ticker';
import LogoBar from '../components/LogoBar/LogoBar';
import ComplianceStrip from '../components/ComplianceStrip/ComplianceStrip';
import StatsCounter from '../components/StatsCounter/StatsCounter';
import Services from '../components/Services/Services';
import CodePreview from '../components/CodePreview/CodePreview';
import PaymentMethods from '../components/PaymentMethods/PaymentMethods';
import Benefits from '../components/Benefits/Benefits';
import Contact from '../components/Contact/Contact';
import SectionDivider from '../components/SectionDivider/SectionDivider';
import WorldMap from '../components/WorldMap/WorldMap';
import AIMascots from '../components/AIMascots/AIMascots';

export default function Home() {
  const location = useLocation();

  /* Tras navegar a /#services (o state desde el menú): scroll suave a la sección cuando el DOM ya incluye #services */
  useLayoutEffect(() => {
    if (location.pathname !== '/') return;
    const go =
      location.hash === '#services' || location.state?.scrollToServices === true;
    if (!go) return;
    const el = document.getElementById('services');
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [location.pathname, location.hash, location.state]);

  return (
    <>
      <Hero />
      <Ticker />
      <LogoBar />
      <ComplianceStrip />
      <StatsCounter />
      <SectionDivider variant="brand" fromColor="transparent" toColor="transparent" />
      <Services />
      <WorldMap />
      <CodePreview />
      <PaymentMethods />
      <SectionDivider variant="glow" />
      <Benefits />
      <AIMascots />
      <Contact />
    </>
  );
}
